module.exports = __webpack_public_path__ + "img/myjf.35b3b58d.png";